export default __webpack_public_path__ + "static/media/tg-logo.92f32cfd.jpeg";